"use client";

import { IconContainerProps, Rating as MuiRating } from "@mui/material";
import { FieldValues, useController } from "react-hook-form";
import { cn } from "@/src/shared/utils/mergeTwClasses";
import Star from "@/public/icons/star";
import {validationRules} from "@/src/shared/utils/validationRules";

export const RatingField = <T extends FieldValues>({
  control,
  name,
  defaultValue,
  helperText,
  displayName,
  hideLabel,
  labelCaption,
  hintIcon,
  toggleHintArea,
  closeHintArea,
  openHintArea,
  required,
  disabled,
  deps,
  onChange: onChangeController,
  ...rest
}: any) => {
  const {
    field: { onChange, value, ref, name: fieldName },
    fieldState: { error: fieldError },
  } = useController({ control, name, defaultValue,
    rules: validationRules.RatingInput({ required, disabled, deps }),
  });

  return (
    <MuiRating
      {...rest}
      precision={1}
      defaultValue={0}
      IconContainerComponent={(props: IconContainerProps) => (
        <span {...props} className={cn(props.className, "mx-2")}>
          <Star />
        </span>
      )}
      onChange={(e, value) => {
        onChange(value);
        onChangeController?.(value);
      }}
      helperText={fieldError?.message}
      error={!!fieldError}
      name={fieldName}
      value={value}
      ref={ref}
    />
  );
};
